import { CronosState, initialState } from "../state/CronosState";
import { CronosActions } from "../action/CronosActions";
import { CronosActionTypes } from "../action";

export function cronosReducer(state: CronosState = initialState, action: CronosActions): CronosState {
    switch (action.type) {
        case CronosActionTypes.CLEAR_ERRORS: 
            return {
                ...state, 
                loadingTeams: false, 
                errorLoadingTeams: false, 
                loadingProjects: false, 
                errorLoadingProjects: false, 
                savingReoder: false, 
                errorReorder: false,
                savingTask: false,
                errorTask: false,
                savingComment: false,
                errorComment: false,
                savingFile: false,
                errorFile: false,
            };
        case CronosActionTypes.LIST_TEAMS:
            return {...state, loadingTeams: true, errorLoadingTeams: false, teams: null};
        case CronosActionTypes.LIST_TEAMS_SUCCESS:
            return {...state, loadingTeams: false, errorLoadingTeams: false, teams: action.teams};
        case CronosActionTypes.LIST_TEAMS_ERROR:
            return {...state, loadingTeams: true, errorLoadingTeams: true, teams: null};
        case CronosActionTypes.LIST_PROJECTS:
            return {...state, loadingProjects: true, errorLoadingProjects: false, projects: null};
        case CronosActionTypes.LIST_PROJECTS_SUCCESS:
            return {...state, loadingProjects: false, errorLoadingProjects: false, projects: action.projects};
        case CronosActionTypes.LIST_PROJECTS_ERROR:
            return {...state, loadingProjects: true, errorLoadingProjects: true, projects: null};
        case CronosActionTypes.SAVE_PROJECT:
            return {...state, savingProject: true, errorSavingProject: false};
        case CronosActionTypes.SAVE_PROJECT_SUCCESS:
            let projects0 = state.projects;
            let foundProject = false;
            projects0.forEach(project => {
                if (project.id == action.savedProjectData.id) {
                    foundProject = true;
                    project.lists = action.savedProjectData.lists;
                }
            });
            if (!foundProject) {
                state.projects.push(action.savedProjectData);
            }
            return {...state, savingProject: false, errorSavingProject: false, projects: projects0, savedProjectData: action.savedProjectData};
        case CronosActionTypes.SAVE_PROJECT_ERROR:
            return {...state, savingProject: false, errorSavingProject: true};
        case CronosActionTypes.REORDER:
            return {...state, savingReoder: true, errorReorder: false};
        case CronosActionTypes.REORDER_SUCCESS:
            let projects = state.projects;
            projects.forEach(project => {
                if (project.id == action.actionProjectId) {
                    let foundList = false;
                    project.lists.forEach(list => {
                        if (list.id == action.reorderData.id) {
                            foundList = true;
                            list.tasks = action.reorderData.tasks;
                        }
                    });
                    if (!foundList) {
                        project.lists.push(action.reorderData);
                    }
                }
            });
            return {...state, savingReoder: false, errorReorder: false, projects: projects};
        case CronosActionTypes.REORDER_ERROR:
            return {...state, savingReoder: false, errorReorder: true};
        case CronosActionTypes.SAVE_TASK:
            return {...state, savingTask: true, errorTask: false, savedTaskData: null};
        case CronosActionTypes.SAVE_TASK_SUCCESS:
            let projects2 = state.projects;
            projects2.forEach(project => {
                if (project.id == action.actionProjectId) {
                    project.lists.forEach(list => {
                        if (list.id == action.actionListId) {
                            let found = false;
                            list.tasks.forEach(task => {
                                if (task.id == action.savedTaskData.id) {
                                    found = true;
                                    task = action.savedTaskData;
                                }
                            });
                            if (!found) {
                                list.tasks.push(action.savedTaskData);
                            }
                        }
                    });
                }
            });
            return {...state, savingTask: false, errorTask: false, projects: projects2, savedTaskData: action.savedTaskData};
        case CronosActionTypes.SAVE_TASK_ERROR:
            return {...state, savingTask: false, errorTask: true, savedTaskData: null};
        case CronosActionTypes.REMOVE_TASK:
            return {...state, removingTask: true, errorRemovingTask: false};
        case CronosActionTypes.REMOVE_TASK_SUCCESS:
            let projects3 = state.projects;
            projects3.forEach(project => {
                if (project.id == action.actionProjectId) {
                    project.lists.forEach(list => {
                        if (list.id == action.actionListId) {
                            let idx = list.tasks.findIndex(x => x.id == action.actionListId);
                            if (idx != null) {
                                list.tasks.splice(idx, 1);
                            }
                        }
                    });
                }
            });
            return {...state, removingTask: false, errorRemovingTask: false, projects: projects3, savedTaskData: action.savedTaskData};
        case CronosActionTypes.REMOVE_TASK_ERROR:
            return {...state, removingTask: false, errorRemovingTask: true};
        case CronosActionTypes.SAVE_COMMENT:
            return {...state, savingComment: true, errorComment: false};
        case CronosActionTypes.SAVE_COMMENT_SUCCESS:
            let projects4 = state.projects;
            projects4.forEach(project => {
                if (project.id == action.actionProjectId) {
                    project.lists.forEach(list => {
                        if (list.id == action.actionListId) {
                            list.tasks.forEach(task => {
                                if (task.id == action.actionTaskId) {
                                    task.comments.push(action.savedCommentData);
                                }
                            });
                        }
                    });
                }
            });
            return {...state, savingComment: false, errorComment: false, projects: projects4};
        case CronosActionTypes.SAVE_COMMENT_ERROR:
            return {...state, savingComment: false, errorComment: true};
        case CronosActionTypes.SAVE_FILE:
            return {...state, savingFile: true, errorFile: false, fileData: null};
        case CronosActionTypes.SAVE_FILE_SUCCESS:
            return {...state, savingFile: false, errorFile: false, fileData: action.savedFileData};
        case CronosActionTypes.SAVE_FILE_ERROR:
            return {...state, savingFile: false, errorFile: true, fileData: null};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducer/CronosReducer.ts